import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { queryClient } from "@/shared/lib/react-query";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { extractSignXml } from "@shared/ui";
import { usePostSignEntryPartOne } from "../mutate-hooks/use-post-sign-entry-part-one";
import { usePostSignEntryPartTwo } from "../mutate-hooks/use-post-sign-entry-part-two";

export const useWithSignedString = () => {
  const { mutateAsync: postSignOne } = usePostSignEntryPartOne();
  const { mutateAsync: postSignTwo } = usePostSignEntryPartTwo();

  const withSignedStringPartOne = async (
    params: {
      sectionFourListId: string;
      itemNoVersionId: string;
      itemPartOneId: string;
      signerEmployeeId: string;
      onSuccess?: () => void;
    },
    signedXml: string,
    mchdId?: string,
  ) => {
    try {
      const signXml = extractSignXml(signedXml);
      await postSignOne({
        params: {
          header: {
            "X-Auth": localStorage.getItem("token") || "",
          },
          path: {
            sectionFourListId: params.sectionFourListId,
            itemNoVersionId: params.itemNoVersionId,
            itemPartOneId: params.itemPartOneId,
          },
        },
        body: {
          signer: { signerEmployeeId: params.signerEmployeeId },
          signXml,
          ...(mchdId ? { mchdId } : {}),
        },
      });
      params.onSuccess?.();
      // Refresh item info to update buttons without page reload
      queryClient.invalidateQueries({
        queryKey: journalsQueries.getSectionFourItem({ itemNoVersionId: params.itemNoVersionId }).queryKey,
      });
    } catch (err: any) {
      notification.error({
        message: NOTIFICATION_MESSAGES.XML_SIGN_P1_SEND_ERROR, // "Ошибка отправки подписи (часть 1)"
        description:
          err?.response?.data?.errorDescription || "Неизвестная ошибка",
        placement: "topRight",
      });
    }
  };

  const withSignedStringPartTwo = async (
    params: {
      sectionFourListId: string;
      itemNoVersionId: string;
      itemPartTwoId: string;
      signerEmployeeId: string;
      onSuccess?: () => void;
    },
    signedXml: string,
    mchdId?: string,
  ) => {
    try {
      const signXml = extractSignXml(signedXml);
      await postSignTwo({
        params: {
          path: {
            sectionFourListId: params.sectionFourListId,
            itemNoVersionId: params.itemNoVersionId,
            itemPartTwoId: params.itemPartTwoId,
          },
          header: {
            "X-Auth": localStorage.getItem("token") || "",
          },
        },
        body: {
          signer: { signerEmployeeId: params.signerEmployeeId },
          signXml,
          ...(mchdId ? { mchdId } : {}),
        },
      });
      params.onSuccess?.();
      queryClient.invalidateQueries({
        queryKey: journalsQueries.getSectionFourItem({ itemNoVersionId: params.itemNoVersionId }).queryKey,
      });
    } catch (err: any) {
      notification.error({
        message: NOTIFICATION_MESSAGES.XML_SIGN_P2_SEND_ERROR, // "Ошибка отправки подписи (часть 2)"
        description:
          err?.response?.data?.errorDescription || "Неизвестная ошибка",
        placement: "topRight",
      });
    }
  };

  return {
    withSignedStringPartOne,
    withSignedStringPartTwo,
  };
};
